<template>
  <section class="container">
    <div class="inner">
      <Heading>
        <template #heading>
          抽選会キーワード<PresentIcon />を3つ集めて<br>
          豪華商品を当てよう<br>
          <a class="link" href="https://festa.l-ma.co.jp/202007/present">商品一覧をCHECK</a>
        </template>
      </Heading>
      <a class="box-wrapper" href="https://festa.l-ma.co.jp/202007/present">
        <div class="box">
          <img src="/img/present07/tp01.png">
        </div>
        <div class="box">
          <p>抽選会<br>エントリーフォームは<br>チケットを取得してGET</p>
        </div>
        <div class="box">
          <p>15:50からLIVEで<br>当選者発表</p>
        </div>
        <div class="box">
          <img src="/img/present07/tp02.png">
        </div>
      </a>
      <div class="sign-up">
        <a class="signtitle" href="https://l-ma.co.jp/events/4851">抽選会参加チケットを取得</a>
        <p class="signtxt">当日の抽選会にエントリーできるのはリトル・ママ会員のみ</p>
      </div>
    </div>
  </section>
</template>

<script>
import Heading from '@/components/atoms/Heading.vue'
import PresentIcon from '@/components/atoms/PresentIcon.vue'

export default {
  components: {
    Heading,
    PresentIcon
  }
}
</script>

<style lang="sass" scoped>
section
  background-color: $pink
  padding: 15px 0 25px
.heading
  color: #fff
  vertical-align: middle
  .present-icon
    vertical-align: middle
    margin: 0 .3em
.link
  color: blue
  text-decoration: underline
.box-wrapper
  display: flex
  flex-wrap: wrap
  border-radius: 16px
  overflow: hidden
  margin: 15px 0
  .box
    display: flex
    justify-content: center
    align-items: center
    width: 50%
    color: $pink
    background-color: $lightpink
    overflow: hidden
    line-height: 1.6
    text-align: center
    font-size: 1.6rem
    @media only screen and (max-width: 600px)
      height: 128px
    @media only screen and (min-width: 601px)
      height: 214px
.sign-up
  text-align: center
  color: #fff
.signtitle
  color: #fff
  text-decoration: underline
  font-size: 20px
.signtxt
  font-size: 12px
  margin-top: 15px
  opacity: 0.8
</style>
